import "./style.scss";
import * as React from "react";
import { FlyerPage } from "./types";

const BASE_URL = "https://f.wishabi.net/";

interface FlyerImageProps {
  page: FlyerPage;
  resolution: "high" | "med" | "low";
  id: string;
  onLoad: (e: any) => void;
}

export class FlyerImage extends React.Component<FlyerImageProps, any> {
  render() {
    const pageNumber = this.props.page.page;
    const highRes = this.props.resolution === "high";
    const flyerImageS3Key = highRes
      ? this.props.page.thumbnail_image_1000w_s3_key
      : this.props.page.thumbnail_image_400h_s3_key;
    const src = BASE_URL + flyerImageS3Key;
    return <img id={this.props.id} onLoad={this.props.onLoad} src={src} />;
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Chart/Heatmap/FlyerImage.tsx